/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
function flickityCarouselBlock () {
    const blocks = document.querySelectorAll( '.wp-block-leanpathblocks-carousel-block' )
    if ( !blocks.length ) return

    blocks.forEach( ( block ) => {
        const items = block.querySelectorAll( '.carousel-slide' )
        if ( !items.length ) return

        const holder = block.querySelector( '.carousel-block' )
        const flickity = new Flickity( holder, {
            prevNextButtons: false,
            cellAlign: 'left',
            groupCells: false,
            imagesLoaded: true,
            pageDots: false,
            percentPosition: true,
            autoPlay: false,
            pauseAutoPlayOnHover: false,
            cellSelector: '.carousel-slide',
            selectedAttraction: 0.05,
            wrapAround: false,
            friction: 0.5,
            adaptiveHeight: true,
            draggable: false
        } );

        if ( window.matchMedia( '(max-width: 767px)' ).matches ) {
            flickity.options.draggable = true;
            flickity.updateDraggable();
        }

        const nextButton = block.querySelector( '.carousel-block__next' );
        nextButton.addEventListener('click', function() {
            if (flickity.selectedIndex === flickity.slides.length - 1 ) {
                flickity.select(0);
            } else{
                flickity.next();
            }
        });
        
        const prevButton = block.querySelector( '.carousel-block__prev' );
        prevButton.addEventListener('click', function() {
            if (flickity.selectedIndex === 0) {
                flickity.select( flickity.slides.length - 1 )
            } else {
                flickity.previous();
            }
            
        });
    } )
}

flickityCarouselBlock ()